import React from 'react';
import ReactDOM from 'react-dom';
import trackLink from '@99designs/common/utils/platform/trackLink';
import { EVENT_CLICKED_INVITE_BUTTON } from 'apps/find-designers/consts';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import FavoriteButton from 'components/FavoriteButton';
import { ExperimentsConsumer } from 'components/ExperimentsContext';
import InviteContext from 'apps/find-designers/components/InviteContext';

class DesignerActions extends React.Component {
    componentDidMount() {
        this.trackInviteClick();
    }

    trackInviteClick() {
        trackLink(
            ReactDOM.findDOMNode(this.inviteButton), // eslint-disable-line react/no-find-dom-node
            EVENT_CLICKED_INVITE_BUTTON,
            {
                designer_id: this.props.designerId,
            }
        );
    }

    favoriteGroupItem() {
        if (!this.props.canFavorite) return null;

        const favoriteUrl = `/profiles/xhr/favorite-designers/${this.props.designerId}`;
        return (
            <ButtonGroupItem>
                <FavoriteButton isFavorite={this.props.isFavorite} favoriteUrl={favoriteUrl} />
            </ButtonGroupItem>
        );
    }

    render() {
        const invitesUrl = `/profiles/${this.props.designerId}/invites/`;

        return (
            <ButtonGroup>
                {this.favoriteGroupItem()}
                <ButtonGroupItem>
                    <ExperimentsConsumer>
                        {data => {
                            if (data && data.inviteToContest === 'enabled') {
                                return (
                                    <InviteContext.Consumer>
                                        {({ onInvite }) => {
                                            return (
                                                <Button
                                                    variations={['small', 'secondary']}
                                                    onClick={() => onInvite()}
                                                    ref={element => {
                                                        this.inviteButton = element;
                                                    }}
                                                >
                                                    <FormattedMessage id="invite" />
                                                </Button>
                                            );
                                        }}
                                    </InviteContext.Consumer>
                                );
                            } else {
                                return (
                                    <Button
                                        variations={['small', 'secondary']}
                                        href={invitesUrl}
                                        ref={element => {
                                            this.inviteButton = element;
                                        }}
                                    >
                                        <FormattedMessage id="invite" />
                                    </Button>
                                );
                            }
                        }}
                    </ExperimentsConsumer>
                </ButtonGroupItem>
            </ButtonGroup>
        );
    }
}

DesignerActions.defaultProps = {
    isFavorite: false,
    onInviteClick: () => undefined,
};

DesignerActions.propTypes = {
    isFavorite: PropTypes.bool,
    canFavorite: PropTypes.bool.isRequired,
    designerId: PropTypes.number.isRequired,
};

export default DesignerActions;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerActions.jsx